<script setup lang="ts">
import { getMainTranslatedSerpTo } from '@@/shared/property/url-serp';

const { locale } = useI18n();
const propertyRecommendationLink = computed(() => {
  if (locale.value === `fr`) return `https://propertips.com`;
  return `https://propertips.com/?lang=en_EN`;
});
const propertySerpTo = computed(() => getMainTranslatedSerpTo(locale.value));
</script>

<template>
  <IadWrapper
    tag="footer"
    class="text-sm"
  >
    <hr class="border-t border-solid border-neutral-70">
    <div class="flex flex-col md:flex-row gap-2xl py-l">
      <div class="flex-1 grid lg:grid-cols-4 gap-y-m">
        <MainFooterSection :title="$t(`core.navigation.section_site`)">
          <MainFooterLink
            :to="propertySerpTo.sale"
            :text="$t(`core.navigation.property_for_sell`)"
            menu-category1="buy"
          />
          <MainFooterLink
            :to="propertySerpTo.rental"
            :text="$t(`core.navigation.property_to_rent`)"
            menu-category1="rent"
          />
          <MainFooterLink
            to="valuation"
            :text="$t(`core.navigation.sell`)"
            menu-category1="sell_estimate"
            menu-category2="sell_with_iad"
          />
          <MainFooterLink
            to="find-real-estate-agent"
            :text="$t(`core.navigation.find_agent`)"
            menu-category1="collaborator_search"
          />
          <MainFooterLink
            href="https://www.join-iad.fr/"
            target="_blank"
            :text="$t(`core.navigation.become_agent`)"
            menu-category1="become_collaborator"
          />
        </MainFooterSection>
        <MainFooterSection :title="$t(`core.navigation.services`)">
          <MainFooterLink
            href="https://blog.iadfrance.fr/"
            :text="$t(`core.navigation.property_advices`)"
            menu-category1="discover_iad"
            menu-category2="buy_sell_advices"
          />
          <MainFooterLink
            to="valuation"
            menu-category1="sell_estimate"
            menu-category2="sell_with_iad"
            :text="$t(`core.navigation.property_valuation`)"
          />
          <MainFooterLink
            :href="propertyRecommendationLink"
            :text="$t(`core.navigation.property_recommendation`)"
            menu-category1="sell_estimate"
            menu-category2="help_a_relative"
          />
          <MainFooterLink
            href="https://www.homepilot.fr/"
            :text="$t(`core.navigation.rental_management`)"
            menu-category1="rent"
            menu-category2="rental_management"
          />
          <MainFooterLink
            href="https://maconciergerie-iad.fr/"
            :text="$t(`core.navigation.concierge`)"
            menu-category1="concierge_moving_services"
          />
        </MainFooterSection>
        <MainFooterSection :title="$t(`core.navigation.section_about`)">
          <MainFooterLink
            href="https://www.iadgroup.com/"
            :text="$t(`core.navigation.iad_group`)"
            menu-category1="iad_group"
          />
          <MainFooterLink
            to="reviews"
            :text="$t(`core.navigation.reviews`)"
            menu-category1="clients_reviews"
          />
          <MainFooterLink
            href="https://www.iadgroup.com/fondation/"
            :text="$t(`core.navigation.iad_foundation`)"
            menu-category1="iad_foundation"
          />
          <MainFooterLink
            href="https://iadfrance-cs.zendesk.com/hc/fr"
            :text="$t(`core.navigation.faq`)"
            menu-category1="faq_page"
          />
          <MainFooterLink
            to="contact-us"
            :text="$t(`core.navigation.contact`)"
            menu-category1="contact_page"
          />
          <MainFooterLink
            href="/bareme_honoraires_iad.pdf"
            :text="$t(`core.common.fee_scales`)"
            menu-category1="fee_tables"
          />
          <MainFooterLink
            href="/bareme_e&c_iad.pdf"
            :text="$t(`core.common.commercial_properties_fee_scales`)"
            menu-category1="e_c_tables"
          />
          <MainFooterLink
            to="mediation"
            :text="$t(`core.navigation.mediation`)"
            menu-category1="mediation"
          />
        </MainFooterSection>
        <MainFooterSection :title="$t(`core.navigation.iad_abroad`)">
          <MainFooterLink
            href="https://www.iadportugal.pt/"
            :text="$t(`references.countries.PT`)"
            menu-category1="portugal_website"
          />
          <MainFooterLink
            href="https://www.iadespana.es/"
            :text="$t(`references.countries.ES`)"
            menu-category1="spain_website"
          />
          <MainFooterLink
            href="https://www.iad-italia.it/"
            :text="$t(`references.countries.IT`)"
            menu-category1="italy_website"
          />
          <MainFooterLink
            href="https://www.iaddeutschland.de/"
            :text="$t(`references.countries.DE`)"
            menu-category1="germany_website"
          />
          <MainFooterLink
            href="https://www.iad.uk.com/"
            :text="$t(`references.countries.GB`)"
            menu-category1="uk_website"
          />
          <MainFooterLink
            href="https://www.iad-us.com/"
            :text="$t(`references.countries.US_FL`)"
            menu-category1="us_website"
          />
          <MainFooterLink
            href="https://www.iadmexico.mx/"
            :text="$t(`references.countries.MX`)"
            menu-category1="mexico_website"
          />
        </MainFooterSection>
      </div>
    </div>
    <hr class="border-t border-solid border-neutral-70">
    <MainFooterBottom />
  </IadWrapper>
</template>
